var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogOut = function SvgLogOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.75 18.75h7.5a1.25 1.25 0 0 0 1.25-1.25v-1.875h-1.25V17.5h-7.5v-15h7.5v1.875h1.25V2.5a1.25 1.25 0 0 0-1.25-1.25h-7.5A1.25 1.25 0 0 0 2.5 2.5v15a1.25 1.25 0 0 0 1.25 1.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m12.866 12.866 2.242-2.241H6.25v-1.25h8.858l-2.242-2.241.884-.884L17.5 10l-3.75 3.75z"
  })));
};
export default SvgLogOut;